import React from 'react';

import { SVGComponentProps } from './svg.types';

const GettingStartedOneSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="72"
        height="72"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="7" y="69" width="58" height="3" fill="#15B9B0" />
        <circle
          cx="27.5945"
          cy="21.5959"
          r="16"
          transform="rotate(75 27.5945 21.5959)"
          fill="#7358E9"
        />
        <circle
          cx="46.0087"
          cy="39.1464"
          r="13"
          transform="rotate(75 46.0087 39.1464)"
          fill="#FF766C"
          stroke="#F9FAFB"
          strokeWidth="2"
        />
      </svg>
    </span>
  );
};

export default GettingStartedOneSVG;
